import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const DoughnutChart = ({ chartData, aspectRatio = 3, isShowPercentage = true }) => {
	const options = {
		responsive: true,
		aspectRatio: aspectRatio,
		maintainAspectRatio: true,
		plugins: {
			legend: {
				display: false
			},
			tooltip: {
				callbacks: {
					label: function (context) {
						var label = context.label,
							currentValue = context.raw,
							total = context.chart._metasets[context.datasetIndex].total;
						var percentage = parseFloat(((currentValue / total) * 100).toFixed(1));
						return (
							' ' +
							label +
							': ' +
							parseFloat(currentValue)?.toFixed(2) +
							`${isShowPercentage ? ' (' + percentage + '%)' : ''}`
						);
					}
				}
			}
		}
	};

	return (
		<div>
			<Doughnut options={options} data={chartData} />
		</div>
	);
};

export default DoughnutChart;
